export const PAGE_SIZE = 25;

export const OFFSET = (page: number) => (page - 1) * PAGE_SIZE;

export const commonColumnProps = {
  width: "auto",
};
